module.exports = __webpack_public_path__ + "9e14e3c1c8ae5d8784d05129e68dd6f8.glb";